import PropTypes from 'prop-types';
import React from 'react';
import launchScoreboard from '../../../utils/scoreboards';

export default class Scoreboard extends React.Component {
  componentDidMount() {
    this.launchScoreboard(this.props.sportName);
  }

  launchScoreboard(sport) {
    try {
      launchScoreboard(`.js-scoreboard-${this.props.id}`, sport);
    } catch (e) {
      // silent catch
    }
  }

  render() {
    const { id, url, sportName } = this.props;

    return (
      <div
        className={`open-bet-scoreboard js-scoreboard-${id}`}
        data-launch-url={url}
        data-sport={sportName}
        data-event-id={id}
      />
    );
  }
}

Scoreboard.propTypes = {
  id: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  sportName: PropTypes.string.isRequired
};
